import { useQuery } from "@tanstack/react-query";
import { APIErrorResponse, IGenericPagination } from "src/types/generic";
import apiClient from "./apiClient";
import { IEmployeeShiftResponse, IOperatorTracking } from "src/types/employees";
import apiFastifyClient from "./apiFastifyCloud";
import { QueryParamValue, toQueryString } from "src/utils";

interface IParams {
  search?: string;
  location?: string;
  cityId?: string;
  limit: number;
  page: number;
  startDate?: number;
  endDate?: number;
}

export const useGetEmployeesShiftsList = (params?: IParams) =>
  useQuery<
    void,
    APIErrorResponse,
    { data: { data: IEmployeeShiftResponse[]; total: number } }
  >({
    queryKey: [
      "get-employees-shifts-list",
      params?.search,
      params?.location,
      params?.cityId,
      params?.limit,
      params?.page,
      params?.startDate,
      params?.endDate,
    ],
    queryFn: async () => {
      return apiClient.get(`/user/shift`, { params: params ?? {} });
    },
    gcTime: 1 * 60 * 60 * 1000, // 1 Hour
  });

export const useExportEmployeesShifts = (params: IParams) =>
  useQuery<IParams, any, any>({
    queryKey: ["export-employees-shifts", params.startDate, params.endDate],
    queryFn: async () => {
      return apiClient.get(`/user/shift/export`, { params });
    },
    enabled: false,
  });

interface ITrackingParams {
  search?: string;
  locations?: string[];
  outOfRange?: boolean;
}

export const useGetEmployeesTrackingList = (params: ITrackingParams) =>
  useQuery<
    void,
    APIErrorResponse,
    {
      data: IOperatorTracking[];
      meta: { count: number; totalAvailable: number; totalOutOfRange: number };
    }
  >({
    queryKey: [
      "get-employees-tracking-list",
      params?.search,
      params?.outOfRange,
      params?.locations,
    ],
    queryFn: async () => {
      const queryString = toQueryString(
        params as unknown as Record<string, QueryParamValue>
      );
      return apiFastifyClient.get(`/v1/shifts?${queryString}`);
    },
    gcTime: 0,
  });

export const useGetEmployeeTrackingByID = (params: { id: string }) =>
  useQuery<
    void,
    APIErrorResponse,
    {
      data: IOperatorTracking;
    }
  >({
    queryKey: ["get-employees-tracking-by-id", params?.id],
    queryFn: async () => {
      // const queryString = toQueryString(
      //   params as unknown as Record<string, QueryParamValue>
      // );
      return apiFastifyClient.get(`/v1/shifts/${params.id}`);
    },
    gcTime: 0,
  });
